import React from "react";

export const HomePage: React.FC = () => {
  return <React.Fragment></React.Fragment>;
};
